import { useParams } from 'react-router-dom'

import { useFormatMessage } from '@/translations/useFormatMessage'
import { Card, CtaLink, LocationHeading, Overlay } from './V2NotEnabled.styled'

interface V2NotEnabledProps {
	locationName: string
}

export function V2NotEnabled({ locationName }: V2NotEnabledProps) {
	const { t } = useFormatMessage()
	const { ref = '' } = useParams()
	const v1Url = `${import.meta.env.VITE_V1_BASE_URL}/${ref}`

	return (
		<Overlay aria-labelledby="v2-not-enabled-title">
			<Card>
				<LocationHeading id="v2-not-enabled-title">{locationName}</LocationHeading>
				<CtaLink href={v1Url}>{t('component:v2NotEnabled:cta')}</CtaLink>
			</Card>
		</Overlay>
	)
}
